import clsx from 'clsx';
import React from 'react';
import { toggleSwitch } from '../../reducers/switch';
import { useDispatch } from 'react-redux';
import ToggleIcon from '../../assets/icons/sidebar-toggle-icon.svg?react';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { useButtonSizeSmaller } from '../../utils/buttonSizes';
import ChevronIcon from '../../assets/icons/chevron-down-icon.svg?react';
import DatePicker from '../../components/DatePicker';
import moment from 'moment';

interface OnboardOrganizationStepOneProps {
  otherClasses?: string;
  formHandler: any;
  handleSteps: React.Dispatch<number>;
}

const OnboardOrganizationStepOne: React.FC<OnboardOrganizationStepOneProps> = ({
  otherClasses,
  formHandler,
  handleSteps,
}) => {
  const onboardOrganizationStepOneClasses = clsx(otherClasses);
  const dispatch = useDispatch();

  return (
    <div
      className={onboardOrganizationStepOneClasses}
      data-testid="onboard-organization-step-One"
    >
      <div className="flex max-w-818 items-start gap-2.5">
        <button
          className="bg-translucent-background/80 border-neutral-tones-text/30 rounded-5 cursor-pointer border p-0.5 lg:hidden"
          onClick={() => dispatch(toggleSwitch())}
        >
          <ToggleIcon />
        </button>
        <div>
          <h1 className="h3">Owner Details</h1>
          <p className="font-inter-variable text-neutral-tones-text/80 -tracking-button mt-15 hidden text-xl leading-6 font-medium lg:block">
            Enter the organization owner's information
          </p>
        </div>
      </div>

      <div className="mt-15 mb-8 flex w-full max-w-955 flex-col gap-6 lg:mt-12">
        <p className="font-inter-variable text-neutral-tones-text/80 -tracking-button -mb-1 text-lg leading-5 font-medium lg:hidden">
          Enter the organization owner's information
        </p>
        <h6 className="text-brand-byzantine font-inter-variable -tracking-button text-xl leading-6 font-bold">
          Personal Details
        </h6>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Input
            onBlur={formHandler?.handleBlur}
            label="Full Name*"
            errorMessage={
              formHandler?.touched.fullName && formHandler?.errors.fullName
                ? formHandler?.errors.fullName
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.fullName}
            type="text"
            placeholder="e.g. Johnny Appleseed"
            onChange={formHandler?.handleChange}
            name="fullName"
            otherClasses={{ container: 'w-full' }}
            autoComplete="new-password"
          />
          <Input
            onBlur={formHandler?.handleBlur}
            label="Email Address*"
            errorMessage={
              formHandler?.touched.email && formHandler?.errors.email
                ? formHandler?.errors.email
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.email}
            type="email"
            placeholder="someone@gmail.com"
            onChange={formHandler?.handleChange}
            name="email"
            otherClasses={{ container: 'w-full' }}
            autoComplete="new-password"
          />
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Input
            onBlur={formHandler.handleBlur}
            label={
              <>
                Contact Number <em className="text-sm font-normal">(Optional)</em>
              </>
            }
            errorMessage={
              formHandler?.touched.contact && formHandler?.errors.contact
                ? formHandler?.errors.contact
                : ''
            }
            disabled={formHandler.isSubmitting}
            value={formHandler.values.contact}
            type="tel"
            placeholder="Enter contact number"
            onChange={formHandler.handleChange}
            name="contact"
            otherClasses={{ container: 'w-full' }}
            autoComplete="new-password"
          />
          <DatePicker
            otherClasses={{ container: 'w-full' }}
            label={
              <>
                Date of Birth <em className="text-sm font-normal">(Optional)</em>
              </>
            }
            name="dob"
            startMonth={moment([1950, 0]).toDate()}
            endMonth={moment().toDate()}
            value={formHandler?.values?.dob}
            placeholder="Select date of birth"
            onBlur={() => {
              if (formHandler?.values?.dob) {
                formHandler?.setFieldTouched('dob', true);
              }
            }}
            disabled={formHandler.isSubmitting}
            onChange={(e) => {
              formHandler?.setFieldValue('dob', e, true);
            }}
            errorMessage={
              formHandler?.touched?.dob && formHandler?.errors.dob
                ? formHandler?.errors.dob
                : ''
            }
          />
        </div>
      </div>

      <Button
        type="button"
        size={useButtonSizeSmaller()}
        onClick={() => handleSteps(2)}
        otherClasses="max-w-211 w-full mt-8"
      >
        Continue
        <ChevronIcon className="h-5 w-5 -rotate-90 [&>path]:fill-current" />
      </Button>
    </div >
  );
};

export default OnboardOrganizationStepOne;